import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInfoCircle } from '@fortawesome/pro-duotone-svg-icons';
import { advantages } from '@/data/advantageData';

const getBgColor = (idx: number, reverse: boolean) =>
  reverse ? (idx % 2 === 0 ? 'bg-base-200' : 'bg-base-100') : idx % 2 === 0 ? 'bg-base-100' : 'bg-base-200';

const SubscriptionAdvantageList = ({ discountCode }: { discountCode?: string }) => {
  return (
    <div className="py-4">
      <div className={`w-full bg-base-200 md:w-11/12 lg:w-full`}>
        <div className="flex h-14 w-full items-center justify-between px-2 text-left">
          <div className="flex w-10/12 items-center lg:w-5/6">
            <div className="overflow-hidden text-ellipsis whitespace-normal max-xs:text-xs">
              Preis / Monat
              <br />
              <span className="text-xs font-normal">(zzgl. MwSt.)</span>
            </div>
          </div>
        </div>
      </div>
      {discountCode && (
        <div className={`w-full bg-base-100 md:w-11/12 lg:w-full`}>
          <div className="flex h-14 w-full items-center justify-between px-2 text-left">
            <div className="flex w-10/12 items-center lg:w-5/6">
              <div className="overflow-hidden text-ellipsis whitespace-normal max-xs:text-xs">
                Rabatt
                <br />
                <span className="overflow-hidden text-ellipsis whitespace-nowrap text-xs font-normal">
                  {discountCode}
                </span>
              </div>
            </div>
          </div>
        </div>
      )}
      {advantages.map((advantage, idx) => (
        <div key={idx} className={`w-full md:w-11/12 lg:w-full ${getBgColor(idx, !!discountCode)}`}>
          <div className="flex h-14 w-full items-center justify-between px-2 text-left">
            <div className="flex w-10/12 items-center lg:w-5/6">
              <FontAwesomeIcon icon={advantage.icon} className="mr-2 h-4 w-4" />
              <div className="overflow-hidden text-ellipsis max-xs:line-clamp-2">{advantage.label}</div>
            </div>
            {advantage.tooltip && (
              <div className="tooltip tooltip-info" data-tip={advantage.tooltip}>
                <FontAwesomeIcon icon={faInfoCircle} className="ml-1 h-4 w-4 xs:ml-2" />
              </div>
            )}
          </div>
        </div>
      ))}
    </div>
  );
};

export default SubscriptionAdvantageList;
